import { Injectable, inject } from '@angular/core';
import { Status } from '@app/shared/models/status.model';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { State } from '../ngrx';
import { GrantType } from '@app/shared/enums/grant-type.enum';
import { appConfig } from '@config/app.config';
import { TokenService } from '@core/services/token.service';
import { AuthorizationService } from '@api/keycloak';
import { createNousTokenFromKeyCloak, NousToken } from '@app/shared/models/nous-token.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly tokenService = inject(TokenService);
  private readonly appState$ = inject<Store<State>>(Store);
  private readonly authService = inject(AuthorizationService);


  getToken(refresh?: boolean): Observable<NousToken> {
    const status = new Status(true);
    const token: NousToken = this.tokenService.getTokenFromStorage();

    if (!token || refresh) {
      return this.fetchTokenFromApi(status, token?.refreshToken);
    }

    status.setSuccess();

    return of(token);
  }

  fetchTokenFromApi(status: Status, refreshToken?: string): Observable<NousToken> {
    const { realm, clientId } = appConfig.cms.auth;
    const { secret } = appConfig.cms.user;

    return this.authService.getToken(
        realm, clientId, GrantType.ClientCredentials, secret, undefined, undefined, undefined, refreshToken
      )
      .pipe(
        map(token => createNousTokenFromKeyCloak(token)),
        catchError(err => this.handleError(err, status)),
        tap(() => status.setSuccess())
      );
  }

  handleError(error: any, status?: Status): Observable<any> {
    status = status || new Status();
    status.setError();

    return throwError(() => error);
  }

}
